export const DashboardReactQueryKey = {
  QueryGetUser: () => ['DashboardReactQueryKey.QueryGetUser']
};
